/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteMessageForSelf.defs.js'
export { main as default } from './deleteMessageForSelf.defs.js'
